import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const CdcAgreementsPage = createLazyPage(
  () =>
    import(
      '@app/modules/filedSettlements/pages/CdcAgreementsPage/CdcAgreementsPage'
    )
);

export const filedSettlementRoutes: AppRouteDefinition[] = [
  {
    key: 'filedsettlements-cdc-agreements',
    path: 'filedsettlements/cdc-agreements',
    element: <CdcAgreementsPage />,
  },
];
